module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.mode.add && _vm.currentWidget.type !== 'hero' && _vm.currentWidget.type !== 'author-carousel') ? _c('button', {
    staticClass: "add-item",
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("Add Item")]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.type === 'top-stories') ? _c('latest-story-preview', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentWidget.type === 'vertical-article-block') ? _c('latest-story-preview', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentWidget.type === 'three-row-column') ? _c('lifestyle-preview', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "maxItems": 3,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentWidget.type === 'author-carousel') ? _c('author-carousel', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "maxItems": 20,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange,
      "setWidgetData": function($event) {
        _vm.$emit('setWidgetData', $event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-443bd3a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalMultiArticle.vue
// module id = 659
// module chunks = 1